import styled, { css } from "styled-components";

export const StyledProgressBarSection = styled.div`
	display: inline-block;
	height: 20px;
	background-color: var(--dz-sys-button-landing-secondary-background-color);

	${({ sectionChecked }) =>
		sectionChecked &&
		css`
			background-color: ${({ theme: { colorsDefaults } }) =>
				colorsDefaults.primary};
		`}
`;
